import { FlaskConical } from 'lucide-react';
import { useBrandingStore } from '../../context/brandingStore';

/**
 * The one thing a sandbox must never let happen is a day's work done in it
 * by somebody who believed it was production. A sandbox holds the MSP's
 * real accounts and real-looking data, signs in with their real passwords,
 * and is reached at an address one word away from the live one. So this is
 * not a toast and it cannot be dismissed: a full-width bar, on the login
 * page before anyone signs in and above every page after, saying what it
 * is and what it does not do.
 *
 * Driven by `GET /api/tenant/resolve`, which the shell awaits before first
 * render (main.jsx), so the bar is on the first paint — a sandbox never
 * looks like production for even a frame.
 */
export default function SandboxBanner() {
  const sandbox = useBrandingStore((s) => s.sandbox);
  const sandboxOf = useBrandingStore((s) => s.sandboxOf);
  if (!sandbox) return null;

  return (
    <div
      role="status"
      data-testid="sandbox-banner"
      className="w-full border-b-2 border-amber-500 bg-amber-400 px-4 py-2 text-center text-sm font-semibold text-amber-950"
    >
      <FlaskConical className="-mt-0.5 mr-1.5 inline h-4 w-4" aria-hidden="true" />
      Sandbox{sandboxOf ? ` copy of ${sandboxOf}` : ''} — nothing here reaches customers, chat or ConnectWise.
      <span className="font-normal"> Changes made here stay here; passwords are the live portal&apos;s and cannot be reset from inside.</span>
    </div>
  );
}
